/**
 * Grindstone screen (vanilla GrindstoneScreen, 176x166): inputs (49,19) and
 * (49,40), result (129,34). Strips enchantments (refunding XP) or merges two items.
 */

import { grindstoneMenu } from '../../game/menu';
import { GuiStage, sheet } from '../kit';
import { ContainerScreen } from './container';
import type { ScreenDeps } from './screenHost';

export interface GrindstoneCtx {
  addXp: (n: number) => void;
  onUse?: () => void;
}

export class GrindstoneScreen extends ContainerScreen {
  constructor(deps: ScreenDeps, stage: GuiStage, ctx: GrindstoneCtx) {
    super(deps, stage);
    this.root.appendChild(sheet('gui/container/grindstone.png', 0, 0, 176, 166, 0, 0));
    // 0 top, 1 bottom, 2 result, 3..29 main, 30..38 hotbar
    this.use(grindstoneMenu(this.env({ addXp: (n) => { ctx.addXp(n); } }), () => ctx.onUse?.()));
    this.at(0, 49, 19); this.at(1, 49, 40); this.at(2, 129, 34);
    this.placePlayer(3, 84, 142);
    this.addLabel('Repair & Disenchant', 8, 6);
    this.addLabel('Inventory', 8, 72);
    this.mount();
  }
}
